import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import MD from 'react-markdown';
import SpaceNav from './Space/SpaceNavigation';
import OpeningHours from './Space/OpeningHours';
import Imageslist from './other/Imagelist';
import Video from './other/Video';

class Space extends Component {
    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            activeH: props.happening
        }
    }

    changeEvent(happening) {
        this.setState({ activeH: happening });
    }

    render() {
        console.log(this.props);
        const events = this.props.allhappenings.filter((o) => {
            return o.eventOrExhibition.indexOf("event") > -1;
        });
        const exhibitions = this.props.allhappenings.filter((o) => {
            return o.eventOrExhibition.indexOf("exhibition") > -1;
        });

        const happening = this.state.activeH;
        const { images, title, date, description, externalLink, externalLinkLabel, video } = happening;

        const parsedDate = moment(date).format("MMMM DD, YYYY h:mm a");
        const parsedEndDate = happening.endDate ? " - " + moment(happening.endDate).format("MMMM DD, YYYY h:mm a") : "";
        // 600 is max-width of #space-page .main
        const featuredImg = images[0].imgType === "gif" ? images[0].url : images[0].url + "&w=600";
        // exclude the 0 image, because it's already used for featuredImg
        const imgList = _.takeRight(images, images.length - 1).map((o, i) => {
            const url = o.imgType === "gif" ? o.url : o.url + "&w=500";
            return url;
        });
        const extLinkLabel = externalLinkLabel || "RSVP";
        const videoUrl = video || "";

        return (
            <div className="content" id="space-page">
              <SpaceNav
                changeEvent={this.changeEvent.bind(this)}
                events={events}
                exhibitions={exhibitions}
                slug={this.state.activeH.slug}
                type={this.state.activeH.eventOrExhibition}
              />
              <div className="two-columns">
                <div className="main">
                  <img src={featuredImg} alt=""/>
                  <h1>{title}</h1>
                  <p>{parsedDate}{parsedEndDate}</p>
                  <MD source={description} />
                  { externalLink && <p><a href={externalLink} className="external-link">{extLinkLabel}</a></p> }
                  { imgList.length > 0 && <Imageslist list={imgList} /> }
                  <Video url={videoUrl} />
                </div>
                <div className="side"></div>
              </div>
              <OpeningHours />
            </div>
        );
    }
}

export default Space;



// WEBPACK FOOTER //
// ./src/components/Space.js